import { CascadePicker as OriginalPicker } from 'antd-mobile';
import React, { forwardRef } from 'react';
export const ModelessCascadePicker = forwardRef((props, ref) => {
    const { render } = props;
    if (props.__designMode === 'design') {
        return React.createElement("div", { ref: ref }, render?.([{ label: '值1' }, { label: '值2' }]));
    }
    return (React.createElement(OriginalPicker, Object.assign({}, props, { ref: ref }), (value) => {
        return render?.(value?.filter((v) => !!v));
    }));
});
export default OriginalPicker;
